import React from 'react';
import classNames from 'classnames';
import BaseButton from 'components/atoms/baseButton';

import s from './styles.module.scss';

import type { IScriptTemplate } from '../types';

interface IProps {
  data: IScriptTemplate;
  selected?: boolean;
  showAdd?: boolean;
  onClick?: (data: IScriptTemplate) => void;
  onAdd?: (data: IScriptTemplate) => void;
}

const Item: React.FC<IProps> = ({
  data,
  selected,
  onClick,
  onAdd,
  showAdd,
}) => {
  const handleClick = () => {
    onClick?.(data);
  };

  const handleAdd = () => {
    onAdd?.(data);
  };

  return (
    <div
      className={classNames(s.item, { [s.selected]: selected })}
      onClick={handleClick}
    >
      {data.name}
      {showAdd && <BaseButton size="default" icon="+" onClick={handleAdd} />}
    </div>
  );
};

export default Item;
